import { Service } from '@/services/api';

class ActivityService extends Service {
  async setUserLastActive(): Promise<void> {
    return this.post<void>('/v1/active', {}).then(this.handleResponse);
  }
}

export const activityService = new ActivityService();
